<template>
  <div :class="{ 'bg-white mx-2': isEditing }">
    <div v-if="isEditing" class="ml-3 pt-2">
      <icon-view
        class="mr-2 rounded-circle"
        icon="fas fa-edit"
        icon-background="white"
        icon-color="#2EB882"
        icon-size="14px"
        title="Editar Información de Licencia"
      />
    </div>
    <div class="px-4 pt-3">
      <validation-observer
        :ref="specialistLicenseFormRef"
        v-slot="{}"
        tag="form"
      >
        <div class="row">
          <div class="col-12">
            <label class="data-label">
              ¿La Licencia es Provisional?
            </label>
          </div>
          <div class="col">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-radio
                v-model="model.provisionalFlag"
                custom-error-msg="Favor de seleccionar si la licencia es provisional o no"
                :error="errors[0]"
                is-inline
                name="rbRecurrenceType"
                :options="provisionalOptions"
              />
            </validation-provider>
          </div>
        </div>

        <div class="row">
          <div
            class="col-sm-12"
            :class="isPsychologist ? 'col-md-3' : 'col-md-4'"
          >
            <label class="data-title mb-0">Especialidad:</label>
            <p v-if="isEditing" class="font-16 font-weight-normal">
              {{ model.specialtyTypeName }}
            </p>
            <validation-provider
              v-else
              v-slot="{ errors }"
              name="licenseSpecialtyType"
              rules="required"
            >
              <custom-drop-down
                v-model="specialtyTypeSelected"
                custom-error-msg="La especialidad es requerida."
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                :options="specialtyTypeOptions"
                placeholder="Seleccione"
                @input="onChangeSpecialtyType"
              />
            </validation-provider>
          </div>
          <div v-if="isPsychologist" class="col-sm-12 col-md-3">
            <label class="data-title mb-0">Nivel de Especialista:</label>
            <validation-provider
              v-slot="{ errors }"
              name="licenseSpecialtyType"
              rules="required"
            >
              <custom-drop-down
                v-model="model.specialtyLevel"
                custom-error-msg="El nivel de especialista es requerido."
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                :options="specialistLevelTypes"
                placeholder="Seleccione"
              />
            </validation-provider>
          </div>
          <div
            class="col-sm-12"
            :class="isPsychologist ? 'col-md-3' : 'col-md-4'"
          >
            <validation-provider
              v-slot="{ errors }"
              name="licenseNumber"
              rules="required"
            >
              <label class="data-title mb-0">Número de Licencia:</label>
              <custom-input
                v-model="model.licenseNo"
                :custom-error-msg="'El número de licencia es requerido.'"
                :error="errors[0]"
              />
            </validation-provider>
          </div>

          <div
            class="col-sm-12"
            :class="isPsychologist ? 'col-md-3' : 'col-md-4'"
          >
            <validation-provider
              v-slot="{ errors }"
              name="licenseAgeRange"
              rules="required"
            >
              <label class="data-title mb-0">Rango de Edad:</label>
              <custom-drop-down
                v-model="ageRangeSelected"
                custom-error-msg="El rango de edad es requerido."
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                :options="ageRanges"
                placeholder="Seleccione"
                @input="onChangeAgeRange"
              />
            </validation-provider>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-3">
            <validation-provider
              v-slot="{ errors }"
              name="licenseDueDate"
              rules="required"
            >
              <label class="data-title mb-0">
                Fecha de Expiración Licencia:
              </label>
              <custom-date-picker
                v-model="model.licenseExpireDate"
                :class-container="'w-100'"
                :custom-error-msg="
                  'La fecha de expiración licencia es requerida.'
                "
                :error="errors[0]"
                format="dd/MMM./yyyy"
                :min-date="currentDate"
              />
            </validation-provider>
          </div>
          <div v-if="!isServiceAssistant" class="col-md-3">
            <validation-provider
              v-slot="{ errors }"
              name="bgClassification"
              :rules="bgClassificationRules"
            >
              <label class="data-title mb-0">
                Clasificación Background Check:
              </label>
              <custom-drop-down
                v-model="bgClassificationSelected"
                custom-error-msg="La clasificación background check es requerida."
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                :options="bgClassificationOptions"
                placeholder="Seleccione"
                @input="onChangeBgClassification"
              />
            </validation-provider>
          </div>
          <div v-if="!isServiceAssistant" class="col-md-3">
            <template
              v-if="
                model.bgClassificationTypeId ===
                  bgClassificationTypes.appointment
              "
            >
              <validation-provider
                v-slot="{ errors }"
                name="bgAppointmentDate"
                :rules="bgAppointmentRules"
              >
                <label class="data-title mb-0">
                  Fecha de Cita Background Check:
                </label>
                <custom-date-picker
                  v-model="model.bgAppointmentDate"
                  :class-container="'w-100'"
                  :custom-error-msg="
                    'La fecha de cita background check es requerida.'
                  "
                  :error="errors[0]"
                  format="dd/MMM./yyyy"
                />
              </validation-provider>
            </template>
            <template v-else>
              <validation-provider
                v-slot="{ errors }"
                name="backgroundCheckDueDate"
                :rules="backgroundRules"
              >
                <label class="data-title mb-0">
                  Fecha de Expiración Background Check:
                </label>
                <custom-date-picker
                  v-model="model.backgroundExpireDate"
                  :class-container="'w-100'"
                  :custom-error-msg="
                    'La fecha de expiración background check es requerida.'
                  "
                  :error="errors[0]"
                  format="dd/MMM./yyyy"
                  :min-date="currentDate"
                />
              </validation-provider>
            </template>
          </div>
          <div class="col-md-3">
            <div class="row">
              <div v-if="specialtyTypeCanSupervise" class="col-md-6">
                <check-box
                  v-model="model.supervisorFlag"
                  class="checkbox"
                  text="Supervisor"
                />
              </div>
            </div>
          </div>
        </div>
        <div v-if="isMedicaidDocumentationWorkflowEnabled" class="row mt-4">
          <div class="col-sm-3 my-2">
            <label class="data-title mb-0">Medicaid ID:</label>

            <validation-provider>
              <custom-input v-model="model.medicalIdentifier" maxlength="100" />
            </validation-provider>
          </div>
          <div class="col-sm-3 my-2">
            <label class="data-title mb-0">
              Fecha de Vencimiento Medicaid:
            </label>
            <custom-date-picker
              v-model="model.medicaidDueDate"
              :class-container="'w-100'"
              format="dd/MMM./yyyy"
              :min-date="new Date()"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-12">
            <span class="font-16 color-black font-weight-bold">
              El especialista tiene la capacidad de ofrecer el(los) servicio(s)
              en:
            </span>
          </div>
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-6">
                <check-box
                  v-model="model.signLanguageFlag"
                  class="checkbox-capacity"
                  text="Lenguaje de Señas"
                />
              </div>
              <div class="col-md-6">
                <check-box
                  v-model="model.englishFlag"
                  class="checkbox-capacity"
                  text="Idioma Inglés"
                />
              </div>
            </div>
          </div>
        </div>
        <div v-for="(document, idx) in model.documents" :key="`type-${idx}`">
          <div
            v-if="
              specialistLicensefileUploadVisibility(
                document.specialistLicenseDocumentTypeId
              )
            "
            class="bg-secondary-3 mt-4 rounded p-4"
            :class="{ 'bg-white': !isEditing }"
          >
            <div class="row">
              <div class="col-md-4">
                <label class="data-title mb-0">Tipo de documento:</label>
                <p>{{ document.specialistLicenseDocumentTypeName | empty }}</p>
              </div>
              <div class="col-md-4">
                <label class="data-title mb-0">Archivo:</label>
                <p v-if="document.documentId || document.guid">
                  {{ document.documentFilename | empty }}
                </p>
                <validation-provider
                  v-else
                  v-slot="{ errors }"
                  :name="
                    specialistLicensefileUploadRef(
                      document.specialistLicenseDocumentTypeId
                    )
                  "
                  :rules="
                    document.specialistLicenseDocumentTypeId !==
                    specialistLicenseDocumentTypes.CertForCyberTherapy
                      ? document.specialistLicenseDocumentTypeId ===
                          specialistLicenseDocumentTypes.Law300 &&
                        isServiceAssistant
                        ? ''
                        : 'required'
                      : ''
                  "
                >
                  <custom-file-input
                    :ref="
                      specialistLicensefileUploadRef(
                        document.specialistLicenseDocumentTypeId
                      )
                    "
                    :accept="allowedFiles"
                    accept-terms-modal-title="Certificación"
                    accept-terms-text="Certifico que este documento que he subido al Sistema REMpro es copia fiel y exacta del original que pertenece a los récords de la Unidad Secretarial del Procedimiento de Querellas y Remedio Provisional (USPQRP) y que como proveedor de servicios seré custodio del mismo. Reconozco y acepto que este documento original me puede ser solicitado por la USPQRP en cualquier momento.(0423)"
                    accept-terms-title="Acepto los términos y responsabilidades"
                    accept-terms-validation-msg="Favor certifique el documento  que ha subido al sistema REMpro."
                    allow-accept-terms
                    :attachment-id="document.documentId"
                    :custom-error-msg="
                      specialistLicenseCustomError(
                        document.specialistLicenseDocumentTypeId
                      )
                    "
                    display-style="normal"
                    :error="errors[0]"
                    label-position="left"
                    :on-download="onDownloadFile"
                    :required="
                      isRequired(document.specialistLicenseDocumentTypeId)
                    "
                    :value="document.attachment"
                    @input="(file) => onChangeFile(file, document)"
                  />
                </validation-provider>
              </div>
              <div
                v-if="document.documentId || document.guid"
                class="col-md-2 pl-0"
              >
                <div class="mt-3 ">
                  <action-button
                    class="mr-2 border-green document-button-icon"
                    i="fas fa-file-download text-green mr-n1 pr-1"
                    @click="downloadDocument(document)"
                  />
                  <action-button
                    class="border-danger document-button-icon"
                    i="fas fa-times-circle text-red mr-n1 pr-1"
                    @click="deleteDocument(document)"
                  />
                </div>
              </div>
              <div
                v-if="
                  document.specialistLicenseDocumentTypeId ===
                    specialistLicenseDocumentTypes.CertForCyberTherapy &&
                    (document.documentId || document.guid)
                "
                class="col-md pl-0 pr-1"
              >
                <label class="data-title mb-0">Fecha de Expiración:</label>
                <validation-provider
                  v-slot="{ errors }"
                  name="licenseDocumentExpiryDate"
                  :rules="
                    document.specialistLicenseDocumentTypeId ===
                      specialistLicenseDocumentTypes.CertForCyberTherapy &&
                    (document.licenseDocumentExpiryDate === undefined ||
                      document.licenseDocumentExpiryDate === null)
                      ? 'required'
                      : ''
                  "
                >
                  <custom-date-picker
                    v-if="document.guid"
                    v-model="document.licenseDocumentExpiryDate"
                    :class-container="'w-100'"
                    :custom-error-msg="'La fecha de expiración es requerida.'"
                    :error="errors[0]"
                    format="dd/MMM./yyyy"
                    :min-date="currentDate"
                  />
                </validation-provider>
                <div>
                  <label v-if="document.documentId" for="">
                    {{ document.licenseDocumentExpiryDate | date }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
    </div>
    <div class="row mt-4 mx-2 pb-3">
      <div class="col-12">
        <action-button
          class="float-right ml-2"
          :i="saveActionIcon"
          :text="saveActionText"
          variant="success"
          @click="save"
        />
        <action-button
          class="float-right"
          i="fas fa-times-circle"
          text="Cancelar"
          variant="outline-danger"
          @click="cancel"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import CustomDatePicker from 'custom-date-picker';
import CheckBox from 'CheckBox';
import CustomFileInput from 'CustomFileInput';
import alert from 'utils/mixins/alert.mixin.js';
import SpecialistLicenseDocumentTypes from '@/utils/constants/specialistLicenseDocumentTypes.js';
import SpecialistTypes from '@/utils/constants/specialtyTypes.js';
import IconView from 'icon-view';
import { getByParameterName } from '@/services/common/sysparameter.api';
import CustomRadio from 'custom-radio';
import { getSpecialtyLevelTypes } from '@/services/provider/specialist.api.js';
import { classificationTypes } from '@/utils/constants/contractDocumentClassificationTypes.js';

export default {
  name: 'SpecialistLicense',
  components: {
    ValidationProvider,
    CustomDropDown,
    CustomInput,
    ActionButton,
    CustomDatePicker,
    CheckBox,
    CustomFileInput,
    IconView,
    CustomRadio,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    specialtyTypes: {
      type: Array,
      default: () => [],
    },
    ageRanges: {
      type: Array,
      default: () => [],
    },
    excludedSpecialtyTypes: {
      type: Array,
      default: () => [],
    },
    activateSpecialistLicenseFilterByHealthDepartment: {
      type: Boolean,
      default: false,
    },
    isMedicaidDocumentationWorkflowEnabled: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [alert],
  data() {
    return {
      provisionalFlagIndex: 0,
      specialtyTypeSelected: null,
      ageRangeSelected: null,
      bgClassificationSelected: null,
      documentSelectedId: null,
      cyberAllowedSpecialties: [],
      provisionalFlag: null,
      provisionalOptions: [
        { name: 'answerYes', label: 'Sí', value: true },
        { name: 'answerNo', label: 'No', value: false },
      ],
      specialistLevelTypes: [],
    };
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    specialistLicenseDocumentTypes() {
      return SpecialistLicenseDocumentTypes;
    },
    saveActionText() {
      return this.isEditing ? 'Guardar' : 'Añadir';
    },
    saveActionIcon() {
      return `fas ${this.isEditing ? 'fa-save' : 'fa-file-medical'} fa-lg`;
    },
    currentDate() {
      let date = new Date();
      date.setDate(date.getDate() - 1);
      return date;
    },
    specialtyTypeOptions() {
      let filtered = [...this.specialtyTypes];
      if (this.excludedSpecialtyTypes) {
        filtered = filtered.filter(
          (x) =>
            !this.excludedSpecialtyTypes.includes(x.id) ||
            x.id === this.model.specialtyTypeId
        );
      }

      if (
        this.activateSpecialistLicenseFilterByHealthDepartment &&
        !this.model.provisionalFlag
      ) {
        filtered = filtered.filter((s) => !s.isFromHD);
      }

      return filtered;
    },
    isOccupationalTherapistOrTherapyAssistant() {
      if (!this.model.specialtyTypeId) return false;
      return [
        SpecialistTypes.OccupationalTherapyAssistant,
        SpecialistTypes.OccupationalTherapist,
      ].includes(this.model.specialtyTypeId);
    },
    isEditing() {
      return Boolean(this.model.specialistLicenseId);
    },
    specialistLicenseFormRef() {
      if (this.isEditing) `specialistLicense${this.model.specialistLicenseId}`;
      return 'specialistLicense';
    },
    allowedFiles() {
      return '.pdf';
    },
    modalTitle() {
      return 'Certifico que este documento que he subido al Sistema REMpro es copia fiel y exacta del original que pertenece a los récords de la Unidad Secretarial del Procedimiento de Querellas y Remedio Provisional (USPQRP) y que como proveedor de servicios seré custodio del mismo. Reconozco y acepto que este documento original me puede ser solicitado por la USPQRP en cualquier momento.(0423)';
    },
    specialistLicensefileUploadRef() {
      return (specialistLicenseDocumentTypeId) =>
        `specialistLicensefileUploadRef${specialistLicenseDocumentTypeId}`;
    },
    specialistLicensefileUploadVisibility() {
      return (specialistLicenseDocumentTypeId) => {
        if (
          specialistLicenseDocumentTypeId ===
          SpecialistLicenseDocumentTypes.CertForCyberTherapy
        ) {
          return this.cyberAllowedSpecialties.includes(
            this.model.specialtyTypeId
          );
        }

        if (
          specialistLicenseDocumentTypeId !==
          SpecialistLicenseDocumentTypes.Collegiation
        ) {
          return true;
        }
        return this.isOccupationalTherapistOrTherapyAssistant;
      };
    },
    specialistLicenseCustomError() {
      return (specialistLicenseDocumentTypeId) => {
        let message = '';
        switch (specialistLicenseDocumentTypeId) {
          case SpecialistLicenseDocumentTypes.SpecialistLicense:
            message = 'licencia';
            break;
          case SpecialistLicenseDocumentTypes.Collegiation:
            message = 'colegiación';
            break;
          case SpecialistLicenseDocumentTypes.Law300:
            message = 'Certificación del Puerto Rico Background Check Program';
            break;
          default:
            break;
        }
        return `El documento de la ${message} es requerido.`;
      };
    },
    specialtyTypeCanSupervise() {
      return Boolean(this.specialtyTypeSelected?.canSupervise);
    },
    bgClassificationTypes() {
      return classificationTypes;
    },
    bgClassificationOptions() {
      return [
        { id: classificationTypes.appointment, name: 'Cita' },
        { id: classificationTypes.certification, name: 'Certificación' },
      ];
    },
    bgClassificationRules() {
      return !this.isServiceAssistant ? 'required' : '';
    },
    backgroundRules() {
      return !this.isServiceAssistant &&
        this.model.bgClassificationTypeId === classificationTypes.certification
        ? 'required'
        : '';
    },
    bgAppointmentRules() {
      return !this.isServiceAssistant &&
        this.model.bgClassificationTypeId === classificationTypes.appointment
        ? 'required'
        : '';
    },
    isServiceAssistant() {
      return this.model.specialtyTypeId === SpecialistTypes.ServiceAssistant;
    },
    isPsychologist() {
      return (
        this.model.specialtyTypeId === SpecialistTypes.Psychologist &&
        this.isMedicaidDocumentationWorkflowEnabled
      );
    },
  },
  methods: {
    async getSpecialtyLevelTypes() {
      const { data } = await getSpecialtyLevelTypes();
      if (data) {
        this.specialistLevelTypes = data;
      }
    },
    provisionalFlagChanged() {
      this.model.provisionalFlag = this.provisionalFlag;
    },
    onChangeSpecialtyType(item) {
      this.model.specialtyTypeId = item?.id;
      this.model.specialtyTypeName = item?.name;
      if (this.model.supervisorFlag && !this.specialtyTypeCanSupervise) {
        this.model.supervisorFlag = false;
      }
      if (!this.isPsychologist) {
        this.model.specialtyLevel = null;
      }
    },
    onChangeAgeRange(item) {
      this.model.ageRangeCd = item?.id;
      this.model.ageRangeName = item?.name;
    },
    onChangeBgClassification(item) {
      this.model.bgClassificationTypeId = item?.id || null;
      if (item?.id !== classificationTypes.certification)
        this.model.backgroundExpireDate = null;
      if (item?.id !== classificationTypes.appointment)
        this.model.bgAppointmentDate = null;
    },
    async save() {
      const isFormValid = await this.$refs[
        this.specialistLicenseFormRef
      ].validate();
      if (!isFormValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }
      if (!this.specialtyTypeCanSupervise) this.model.supervisorFlag = false;
      this.$emit('save', { ...this.model });
    },
    cancel() {
      this.$emit('cancel');
    },
    async onDownloadFile() {
      return new Promise();
    },
    onChangeFile(file, doc) {
      if (file) {
        this.documentSelectedId = doc.specialistLicenseDocumentTypeId;
        doc.attachment = file;
        doc.documentFilename = file.name;
        doc.guid = this.builtUniqueId();
      }
    },
    downloadDocument(doc) {
      this.$emit('download-document', doc);
    },
    deleteDocument(doc) {
      this.$emit('delete-document', doc, this.model);
    },
    builtUniqueId() {
      return (
        Date.now().toString(36) +
        Math.random()
          .toString(36)
          .substr(2)
      );
    },
    isRequired(specialistLicenseDocumentTypeId) {
      return (
        specialistLicenseDocumentTypeId !==
        SpecialistLicenseDocumentTypes.CertForCyberTherapy
      ).toString();
    },
    async getCyberAllowedSpecialties() {
      const { data } = await getByParameterName(
        'RPCybertherapyAllowedSpecialties'
      );

      if (data) {
        this.cyberAllowedSpecialties = data.value.split(',').map((str) => +str);
      }
    },
  },
  watch: {
    'value.ageRangeCd': {
      immediate: true,
      handler: function(value) {
        if (!value) return;
        if (this.ageRangeSelected) return;
        this.ageRangeSelected = this.ageRanges.find((y) => y.id === value);
      },
    },
    'value.specialtyTypeId': {
      immediate: true,
      handler: function(value) {
        if (!value) return;
        if (this.specialtyTypeSelected) return;
        this.specialtyTypeSelected = this.specialtyTypeOptions.find(
          (y) => y.id === value
        );
      },
    },
    'value.bgClassificationTypeId': {
      immediate: true,
      handler: function(value) {
        if (!value) return;
        this.bgClassificationSelected = this.bgClassificationOptions.find(
          (y) => y.id === value
        );
      },
    },
  },
  async mounted() {
    await this.getCyberAllowedSpecialties();
    await this.getSpecialtyLevelTypes();
  },
};
</script>

<style scoped lang="scss">
.checkbox {
  margin-top: 16% !important;
}
.checkbox-capacity {
  margin-top: 10% !important;
  margin-bottom: 10% !important;
}
.document-button-icon {
  height: 33px;
  width: 33px;
  padding: 0;
}
</style>
